import { boldItalic } from "./barlow-condensed.js";
import { regular, light } from "./crimson-pro.js";
import * as interstate$1 from "./interstate.js";
import { convertFontToCss } from "../../utilities/transform/jss.js";
const barlow = {
  boldItalic
};
const crimson = {
  light,
  regular
};
const interstate = {
  ...interstate$1
};
const typographyFontFaceObject = {
  "@font-face": {
    ...barlow,
    ...crimson,
    ...interstate
  }
};
const families = { barlow, crimson, interstate };
const base64fonts = Object.entries(families).reduce(
  (outerAcc, [key, value]) => {
    const innerResult = Object.entries(value).reduce(
      (innerAcc, [fontKey, fontValue]) => {
        return innerAcc + convertFontToCss(fontValue) + "\n";
      },
      ""
    );
    return outerAcc + innerResult;
  },
  ""
);
export {
  barlow,
  base64fonts,
  crimson,
  families,
  interstate,
  typographyFontFaceObject
};
//# sourceMappingURL=index.js.map
